// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightCircleFilledSvg from "@ant-design/icons-svg/es/asn/CopyrightCircleFilled";
import AntdIcon from '../components/AntdIcon';

var CopyrightCircleFilled = function CopyrightCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleFilledSvg
  }));
};

CopyrightCircleFilled.displayName = 'CopyrightCircleFilled';
export default React.forwardRef(CopyrightCircleFilled);